import { useEffect } from "react";
import { sendPdfToHost } from "../../lib/nativeMode";

interface HiddenPdfLoaderProps {
  src: string;
  title: string;
}

/**
 * The `?isMobile` stand-in for a PDF window.
 *
 * Everything the visible window does still happens — the iframe mounts and
 * requests the PDF, so any navigation/download handler the host webview has
 * installed still fires — but nothing is shown, because the host presents the
 * document itself. The URL is also pushed to the host over the bridge.
 *
 * Kept on-page and merely moved out of view rather than `display: none`, so
 * there's no chance of an engine skipping the load.
 */
const HiddenPdfLoader = ({ src, title }: HiddenPdfLoaderProps) => {
  useEffect(() => {
    if (src) sendPdfToHost(src, title);
  }, [src, title]);

  if (!src) return null;

  return (
    <iframe
      src={src}
      title={title}
      aria-hidden
      tabIndex={-1}
      style={{
        position: "fixed",
        left: -10000,
        top: 0,
        width: 1,
        height: 1,
        opacity: 0,
        pointerEvents: "none",
        border: 0,
      }}
    />
  );
};

export default HiddenPdfLoader;
